












import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { SessionFeedback } from "../../types";

@Component
export default class UserReviewTranscript extends Vue {
  @Prop() private transcript!: string[];
  @Prop() private isPortrait!: boolean;
  @Prop() private isUserFromLearner!: boolean;
  @Prop() private scrollY!: number;

  @Action private setTranscriptStartIndex!: any;
  @Action private setTranscriptEndIndex!: any;
  @Action private setNewReviewCommentVisible!: any;

  @Getter private transcriptStartIndex!: number;
  @Getter private transcriptEndIndex!: number;
  @Getter private reviewCommentSelectedIndex!: number;
  @Getter private newReviewCommentVisible!: boolean;
  @Getter private sessionFeedback!: SessionFeedback[];

  private isNewCommentIcon: boolean = true;
  private marginTop: number = 0;
  private marginLeft: number = 0;

  private highlightElTemplate: HTMLElement = document.createElement("span");

  private newCommentDefaultImage = require("../../assets/images/addReviewComment.svg");
  private newCommentImageHover = require("../../assets/images/addReviewCommentHover.svg");
  private newCommentImage = this.newCommentDefaultImage;
  
  private created() {
    this.highlightElTemplate.className = "highlight";
  }

  private handleMouseUp(event: Event) {
    if(this.isUserFromLearner) return;
    let selection: any = window.getSelection();
    const transcriptTextEl = this.$refs.transcriptText as HTMLElement;
    const childNodes = transcriptTextEl.childNodes;
    let numEmpty = 0;
    let startIndex = -1;
    let endIndex = -1;

    if (selection.toString().length) {
      for (let i = 0; i < childNodes.length; i++) {
        let node = childNodes[i] as HTMLElement;
        // Skip and count whitespace textNodes
        if (!/\S/.test(node.textContent as string)) {
          numEmpty++;
          continue;
        }

        let rangeCount = selection.rangeCount;
        var range = selection.getRangeAt(0);
        var selectionRect = range.getClientRects();
        let marginTop = selectionRect[selectionRect.length - 1].bottom;
        let marginLeft = selectionRect[selectionRect.length - 1].right;
        
        if (this.isPortrait) {
          marginTop -= 100;
          marginLeft = marginLeft - transcriptTextEl.offsetWidth - 110; 
        } else {
          marginTop -= 42;
          marginLeft = marginLeft - 70 
        }
       this.marginLeft = marginLeft;
       this.marginTop = marginTop+this.scrollY;

        if (
          node === selection.anchorNode ||
          node === selection.anchorNode.parentNode
        ) {
          startIndex = i - numEmpty;
          if (endIndex >= 0) break;
        }

        if (
          node === selection.focusNode ||
          node === selection.focusNode.parentNode
        ) {
          endIndex = i - numEmpty;
          if (startIndex >= 0) break;
        }
      }
    }

    if (startIndex == -1 && endIndex == -1) {
      this.isNewCommentIcon = true;
      this.setNewReviewCommentVisible(false);
    }

    if (startIndex < endIndex) {
      this.setTranscriptSelectionIndex(startIndex, endIndex);
    } else {
      this.setTranscriptSelectionIndex(endIndex, startIndex);
    }
    this.onTranscriptChanged();
  }

  private toggleNewReviewComment() {
    if (this.newReviewCommentVisible) {
      this.setTranscriptSelectionIndex(-1, -1);
    }

    this.setNewReviewCommentVisible(!this.newReviewCommentVisible);
    this.isNewCommentIcon = false;
  }

  private setTranscriptSelectionIndex(startIndex: number, endIndex: number) {
    this.setTranscriptStartIndex(startIndex);
    this.setTranscriptEndIndex(endIndex);
  }

  @Watch("sessionFeedback")
  private onSessionFeedback() {
    this.onTranscriptChanged();
  }

  @Watch("transcriptStartIndex")
  private onStartIndexChanged() {
    this.onTranscriptChanged();
  }

  @Watch("reviewCommentSelectedIndex")
  private onReviewCommentSelectedIndex() {
    this.onTranscriptChanged();
  }

  private mounted() {
    this.onTranscriptChanged();
  }

  @Watch("transcript")
  private onTranscriptChanged() {
    const appendSlicedText = (
      wordArray: string[],
      el: HTMLElement,
      start: number,
      end: number
    ) => {
      let beforeSpace = " ";
      if (start === 0) {
        beforeSpace = "";
      }
      const text = wordArray.slice(start, end);
      const textNode = document.createTextNode(
        beforeSpace + text.join(" ") + " "
      );
      el.appendChild(textNode);
    };

    // Parse text data
    const transcriptTextEl = this.$refs.transcriptText as HTMLElement;
    transcriptTextEl.innerHTML = "";
    let textStart = 0;
    const wordArray = this.transcript;
    let index = 0;
    for (index = 0; index < wordArray.length; index++) {
      const word = wordArray[index];
      const wordNode = document.createTextNode(word);
      //let hasBold = true;//this.fillerData.includes(i);
      let hasHighlight = index >= this.transcriptStartIndex && index <= this.transcriptEndIndex;
      let hasFeedback = this.sessionFeedback?this.sessionFeedback.some(item => index >= (item.StartIndex?item.StartIndex:-1) && index <= (item.EndIndex?item.EndIndex:-1)):false;
      
      // Add textNode
      if (index > 0) {
        appendSlicedText(wordArray, transcriptTextEl, textStart, index);
        textStart = index;
      }

      let spanEl;
      if (hasHighlight || hasFeedback) {
        // Add highlight span
        spanEl = this.highlightElTemplate.cloneNode(true) as HTMLElement;
        if (this.reviewCommentSelectedIndex >= 0 && hasFeedback) {
          let selectedFeedback = this.sessionFeedback[this.reviewCommentSelectedIndex]

          if(selectedFeedback && index >= (selectedFeedback.StartIndex?selectedFeedback.StartIndex:-1) && index <= (selectedFeedback.EndIndex?selectedFeedback.EndIndex:-1)) {
            spanEl.classList.add("bold");
          }
        }
      }

      if (spanEl) {
        spanEl.appendChild(wordNode);
        transcriptTextEl.appendChild(spanEl);
        textStart++;
      }
    }

    // Set scroll if highlight offscreen
    let firstHighlight = transcriptTextEl.querySelector(
      ".highlight"
    ) as HTMLElement;
    if (firstHighlight) {
      let offset = firstHighlight.offsetTop;
      transcriptTextEl.scrollTop = offset - transcriptTextEl.clientHeight / 2;
    }

    appendSlicedText(wordArray, transcriptTextEl, textStart, index);
  }
}
